// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__MKm4f","footerText":"Footer_footerText__6czck"};